import { ReactNode, forwardRef, type ComponentProps, type ClipboardEventHandler } from 'react';
import { NumberInput } from '../../atoms/number-input';
import { FieldLayoutWithAction } from '../../layouts/field-layout-with-action';
import type { BasicFormFieldProps, ExtraFieldProps, FieldActionProps } from '../../layouts/types';

type Props = BasicFormFieldProps<'number'> &
  ExtraFieldProps &
  FieldActionProps & {
    endAdornment?: ReactNode;
    maxLength?: number;
    onPaste?: ClipboardEventHandler<HTMLInputElement>;
  };

export const NumberField = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <FieldLayoutWithAction
    {...props}
    //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
    field={NumberInput as ComponentProps<typeof FieldLayoutWithAction>['field']}
    ref={ref}
  />
));

NumberField.displayName = 'NumberField';
